import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_SETTING}/source`

export const SETTINGS_SOURCE: Route = {
  path: base
}

export const SETTINGS_SOURCE_PAGE: Route = {
  path: `${base}?page={page}`
}

export const SETTINGS_SOURCE_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_SOURCE_EDIT: Route = {
  path: `${base}/{id}?page={page}`
}

export const SETTINGS_SOURCE_IMPORT: Route = {
  path: `${base}/import`
}
